import { render, staticRenderFns } from "./TechExpertUsers.vue?vue&type=template&id=338211c2&scoped=true"
import script from "./TechExpertUsers.vue?vue&type=script&lang=js"
export * from "./TechExpertUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338211c2",
  null
  
)

export default component.exports